export const PurchaseOrderRelationsConstant :string[] = [
  'basePrice',
  'tags.tag_details',
  'variantParent',
  'unitOfMeasures',
  'quotations',
];

export const EstimateRelationsConstant :string[] = [
  'category',
  'subcategory',
  'basePrice',
  'tags',
  'stock',
  'unitOfMeasures',
];

export const InvoiceRelationsConstant :string[] = [
  'category',
  'subcategory',
  'basePrice',
  'tags.tag_details',
  'stock',
  'variantParent.category',
  'variantParent.subcategory',
  'variantParent.tags.tag_details',
  'variantParent.unitOfMeasures',
  'unitOfMeasures',
];
